/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type EvmContractVerifyJsonRequest = {
    mainNetType?: EvmContractVerifyJsonRequest.mainNetType;
    contractAddress: string;
    solcVersion: string;
    constructorArgs?: string;
    jsonFile: Blob;
};

export namespace EvmContractVerifyJsonRequest {

    export enum mainNetType {
        DEFAULT = 'DEFAULT',
        DEFAULT_EVM = 'DEFAULT_EVM',
        NEXON = 'NEXON',
        POLYGON = 'POLYGON',
        BASE = 'BASE',
        APTOS = 'APTOS',
        APTOS_DEVNET = 'APTOS_DEVNET',
        ZEROG = 'ZEROG',
        ZEROG_TESTNET = 'ZEROG_TESTNET',
        BABYLON = 'BABYLON',
        BABYLON_TESTNET = 'BABYLON_TESTNET',
        HUMANITY = 'HUMANITY',
        HUMANITY_TESTNET = 'HUMANITY_TESTNET',
        KITE = 'KITE',
        KITE_TESTNET = 'KITE_TESTNET',
        SOMNIA = 'SOMNIA',
    }


}

